// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.powered {
  width: 100%;
  height: 15vh;
  background-color: #1D1A36;
  display: flex;
  align-items: center;
  font-family: Helvetica;
  justify-content: center;
  align-items: baseline;
}
.powered_text {
  color: #ffffff;
  font-size: 1.4rem;
}
.powered_links {
  text-decoration: none;
  color: #ffffff;
}
.powered a:hover {
  color: white;
}

.poweredtexts {
  width: 34.1145833333vw;
  height: 7.4125874126vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #181434;
  background: linear-gradient(146deg, rgb(255, 182, 160) 0%, rgb(240, 89, 42) 26%, rgb(37, 60, 119) 100%);
  border-radius: 1.3986013986vh;
  border: 1px;
  padding: 1px;
}

@media (max-width: 992px) {
  .poweredtexts {
    width: 80.1145833333vw;
  }
}
@media (max-width: 576px) {
  .poweredtexts {
    width: 80.1145833333vw;
  }
}
.poweredtexts span {
  background-color: #1D1A36;
  width: 100%;
  border-radius: 1.3986013986vh;
  text-align: center;
  height: 100%;
}

.poweredBy {
  color: var(--white, #FFF);
  font-family: Roboto;
  font-size: 3.3566433566vh;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.textForBreezy {
  color: var(--white, #FFF);
  font-family: Roboto;
  font-size: 4.1958041958vh;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  text-decoration-line: underline;
}`, "",{"version":3,"sources":["webpack://./src/Components/Powered/powered.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AACF;AACE;EACE,cAAA;EACA,iBAAA;AACJ;AAEE;EACE,qBAAA;EACA,cAAA;AAAJ;AAGE;EACE,YAAA;AADJ;;AAMA;EACE,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uGAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;AAHF;;AAMA;EACE;IACE,sBAAA;EAHF;AACF;AAOA;EACE;IACE,sBAAA;EALF;AACF;AAQA;EACE,yBAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;AANF;;AAUA;EACE,yBAAA;EACF,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAPA;;AAUA;EACE,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;AAPF","sourcesContent":[".powered {\n  width: 100%;\n  height: 15vh;\n  background-color: #1D1A36;\n  display: flex;\n  align-items: center;\n  font-family: Helvetica;\n  justify-content: center;\n  align-items: baseline;\n\n  &_text {\n    color: #ffffff;\n    font-size: 1.4rem;\n  }\n\n  &_links {\n    text-decoration: none;\n    color: #ffffff;\n  }\n\n  a:hover {\n    color: white;\n  }\n}\n\n\n.poweredtexts{\n  width: 34.114583333333336vw;\n  height:7.4125874125874125vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #181434;\n  background: linear-gradient(146deg, rgba(255,182,160,1) 0%, rgba(240,89,42,1) 26%, rgba(37,60,119,1) 100%);\n  border-radius:1.3986013986013985vh;\n  border: 1px;\n  padding: 1px;\n}\n\n@media (max-width: 992px) {\n  .poweredtexts{\n    width: 80.114583333333336vw;\n  }\n}\n\n\n@media (max-width: 576px) {\n  .poweredtexts{\n    width: 80.114583333333336vw;\n  }\n}\n\n.poweredtexts span{\n  background-color: #1D1A36;\n  width: 100%;\n  border-radius:1.3986013986013985vh;\n  text-align: center;\n  height: 100%;\n  \n}\n\n.poweredBy{\n  color: var(--white, #FFF);\nfont-family: Roboto;\nfont-size:3.3566433566433567vh;\nfont-style: normal;\nfont-weight: 400;\nline-height: 150%;\n}\n\n.textForBreezy{\n  color: var(--white, #FFF);\n  font-family: Roboto;\n  font-size: 4.195804195804196vh;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  text-decoration-line: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
